import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Navigate,
} from 'react-router-dom';

import NotFoundPage from 'components/ui/NotFoundPage';

import BaseLayout from 'layouts/BaseLayout';

import LogInSignUpLayout from 'layouts/LogInSignUpLayout';
import LogIn from 'pages/login-signup/LogIn';
import Order from 'pages/admin/order';
import AddOrder from 'pages/admin/order/items/add';
import Settings from 'pages/admin/settings/Settings';
import Staff from 'pages/admin/settings/staff/Staff';
import Masters from 'pages/admin/settings/master/Master';
import Suppliers from 'pages/admin/settings/supplier/Supplier';
import Partners from 'pages/admin/settings/partner/Partners';
import PartnersHistory from 'pages/admin/settings/partner/history';
import SupplierHistory from 'pages/admin/settings/supplier/history';
import ProductHistory from 'pages/admin/products/history';
import AuthProvider from 'context/providers/AuthProvider';
import BaseProvider from 'context/BaseProvider';
import Permission from 'pages/admin/settings/permission/Permission';
import RequireAuth from 'hoc/RequireAuth';
import RequireChildAuth from 'hoc/RequireChildAuth';
import MainPage from 'pages/admin/main-page/MainPage';
import ProductCategory from 'pages/admin/settings/product-categories/ProductCategory';
import ExpenseCategory from 'pages/admin/settings/expense-categories/ExpenseCategory';
import Products from 'pages/admin/products/Products';
import Expenses from 'pages/admin/expense/Expenses';
import Warehouse from 'pages/admin/warehouse/Warehouse.jsx';
import WarehouseInbound from 'pages/admin/warehouse/items/inbound/WarehouseInbound.jsx';
import WarehouseOutbound from 'pages/admin/warehouse/items/outbound';
import WarehouseChecklist from 'pages/admin/warehouse/items/checklist';
import WarehouseHistory from 'pages/admin/warehouse/items/history/WarehouseHistory.jsx';
import WarehouseOutcome from 'pages/admin/warehouse/items/outcomes/WarehouseOutcome.jsx';
import ReturnProducts from 'pages/admin/warehouse/items/return';
import ReturnedProducts from 'pages/admin/warehouse/items/return/ReturnedProducts';
import Money from 'pages/admin/money';
import PartnerMoney from 'pages/admin/partnermoney';
import INCOMEMONEY from 'pages/admin/incomemoney';
import Account from 'pages/admin/account';
import AccountIncome from 'pages/admin/accountincome';
import AccountConversation from 'pages/admin/account-conversation';
import BossLayout from 'layouts/BossLayout';
import WarehouseStatisticsLayout from 'layouts/WarehouseStatisticsLayout';
import ExpenseStatisticsLayout from 'layouts/ExpenseStatisticsLayout';

import { default as BossResidentialComplex } from 'pages/boss/object';
import { default as AccountStatistics } from 'pages/boss/account';
import { default as ProductStatistics } from 'pages/boss/warehouse/product-statistics';
import { default as ProductIncomes } from 'pages/boss/warehouse/product-incomes';
import { default as ProductRatings } from 'pages/boss/warehouse/product-ratings';
import { default as IncomeOutcomeStatistics } from 'pages/boss/income-outcome';
import { default as ExpenseIncomeOutcomeStatistics } from 'pages/boss/expense/income-outcome';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Outlet />}>
      <Route element={<AuthProvider />}>
        <Route element={<LogInSignUpLayout />}>
          <Route path='login' element={<LogIn />} />
        </Route>
        <Route element={<BaseProvider />}>
          {/* Vaqtincha permission qo'shguncha chora */}
          <Route
            path=''
            element={
              <RequireAuth>
                <Navigate to='admin/main' />
              </RequireAuth>
            }
          />
          <Route
            path='admin'
            element={
              <RequireAuth>
                <Navigate to='admin/main' />
              </RequireAuth>
            }
          />
          <Route element={<Outlet />} path='admin'>
            <Route element={<BaseLayout />}>
              <Route
                path='main'
                element={
                  <RequireAuth permissionCode='MAINPAGE'>
                    <MainPage />
                  </RequireAuth>
                }
              />
              <Route
                path='expenses'
                element={
                  <RequireAuth permissionCode='EXPENSES'>
                    <Expenses />
                  </RequireAuth>
                }
              />
              <Route
                path='products'
                element={
                  <RequireAuth permissionCode='PRODUCTS'>
                    <Outlet />
                  </RequireAuth>
                }
              >
                <Route index element={<Products />} />
                <Route path=':id/history' element={<ProductHistory />} />
              </Route>

              <Route
                path='warehouse'
                element={
                  <RequireAuth permissionCode='WAREHOUSE'>
                    <Outlet />
                  </RequireAuth>
                }
              >
                <Route index element={<Warehouse />} />
                <Route path=':id/inbound' element={<WarehouseInbound />} />
                <Route
                  path=':id/inbound/:inboundId/update'
                  element={<WarehouseInbound />}
                />
                <Route path=':id/outbound' element={<WarehouseOutbound />} />
                <Route path=':id/checklist' element={<WarehouseChecklist />} />
                <Route path=':id/history' element={<WarehouseHistory />} />
                <Route path=':id/outcome' element={<WarehouseOutcome />} />
                <Route path=':id/return-list' element={<ReturnedProducts />} />
                <Route path=':id/return' element={<ReturnProducts />} />
              </Route>
              <Route
                path='order'
                element={
                  <RequireAuth permissionCode='ORDERS'>
                    <Outlet />
                  </RequireAuth>
                }
              >
                <Route index element={<Order />} />
                <Route path='add' element={<AddOrder />} />
                <Route path=':id/edit' element={<AddOrder />} />
              </Route>
              <Route
                path='accounts'
                element={
                  <RequireAuth permissionCode='ACCOUNTS'>
                    <Account />
                  </RequireAuth>
                }
              />
              <Route
                path='account-income'
                element={
                  <RequireAuth permissionCode='RECEIVED_MONEY'>
                    <AccountIncome />
                  </RequireAuth>
                }
              />
              <Route
                path='account-conversation'
                element={
                  <RequireAuth permissionCode='ACCOUNTS'>
                    <AccountConversation />
                  </RequireAuth>
                }
              />
              <Route
                path='money'
                element={
                  <RequireAuth permissionCode='FINANCE'>
                    <Money />
                  </RequireAuth>
                }
              />

              <Route
                path='partner-money'
                element={
                  <RequireAuth permissionCode='PARTNERMONEY'>
                    <PartnerMoney />
                  </RequireAuth>
                }
              />

              <Route
                path='incomemoney'
                element={
                  <RequireAuth permissionCode='INCOMEMONEY'>
                    <INCOMEMONEY />
                  </RequireAuth>
                }
              />

              <Route
                path='settings'
                element={
                  <RequireAuth permissionCode='SETTINGS'>
                    <Outlet />
                  </RequireAuth>
                }
              >
                <Route index element={<Settings />} />

                <Route
                  path='staff'
                  element={
                    <RequireChildAuth
                      parentPermission='SETTINGS'
                      permissionCode='SETTINGS_STAFF'
                    >
                      <Staff />
                    </RequireChildAuth>
                  }
                />
                <Route
                  path='masters'
                  element={
                    <RequireChildAuth
                      parentPermission='SETTINGS'
                      permissionCode='SETTINGS_MASTERS'
                    >
                      <Masters />
                    </RequireChildAuth>
                  }
                />
                <Route
                  path='suppliers'
                  element={
                    <RequireChildAuth
                      parentPermission='SETTINGS'
                      permissionCode='SETTINGS_CONTRAGENTS'
                    >
                      <Outlet />
                    </RequireChildAuth>
                  }
                >
                  <Route index element={<Suppliers />} />
                  <Route path=':id/history' element={<SupplierHistory />} />
                </Route>

                <Route
                  path='partners'
                  element={
                    <RequireChildAuth
                      parentPermission='SETTINGS'
                      permissionCode='SETTINGS_PARTNERS'
                    >
                      <Outlet />
                    </RequireChildAuth>
                  }
                >
                  <Route index element={<Partners />} />
                  <Route path=':id/history' element={<PartnersHistory />} />
                </Route>

                <Route
                  path='product-categories'
                  element={
                    <RequireChildAuth
                      parentPermission='SETTINGS'
                      permissionCode='SETTINGS_PRODUCT_CATEGORIES'
                    >
                      <ProductCategory />
                    </RequireChildAuth>
                  }
                />
                <Route
                  path='expense-categories'
                  element={
                    <RequireChildAuth
                      parentPermission='SETTINGS'
                      permissionCode='SETTINGS_EXPENSE_CATEGORIES'
                    >
                      <ExpenseCategory />
                    </RequireChildAuth>
                  }
                />
                <Route
                  path='permission'
                  element={
                    <RequireChildAuth
                      parentPermission='SETTINGS'
                      permissionCode='SETTINGS_PERMISSIONS'
                    >
                      <Permission />
                    </RequireChildAuth>
                  }
                />
              </Route>

              <Route path='not-found' element={<NotFoundPage />} />
            </Route>
          </Route>

          {/* --------- no used ---------- under line ---------- */}

          <Route
            element={
              <RequireAuth
                // permissionCode='STATISTICS'
                permissionCode='SETTINGS'
                hasChildPermission={true}
              >
                <Outlet />
              </RequireAuth>
            }
            path='statistic'
          >
            <Route element={<BossLayout />}>
              <Route
                path='object'
                element={
                  <RequireChildAuth
                    parentPermission='SETTINGS'
                    permissionCode='SETTINGS_PERMISSIONS'
                  >
                    <BossResidentialComplex />
                  </RequireChildAuth>
                }
              />
              <Route
                path='account'
                element={
                  <RequireChildAuth
                    parentPermission='SETTINGS'
                    permissionCode='SETTINGS_PERMISSIONS'
                  >
                    <AccountStatistics />
                  </RequireChildAuth>
                }
              />
              <Route
                path='income-outcomes'
                element={
                  <RequireChildAuth
                    parentPermission='SETTINGS'
                    permissionCode='SETTINGS_PERMISSIONS'
                  >
                    <IncomeOutcomeStatistics />
                  </RequireChildAuth>
                }
              />
              <Route
                element={
                  <RequireChildAuth
                    parentPermission='SETTINGS'
                    permissionCode='SETTINGS_PERMISSIONS'
                  >
                    <WarehouseStatisticsLayout />
                  </RequireChildAuth>
                }
                path='warehouse'
              >
                <Route index element={<Navigate to='products' />} />
                <Route path='products' element={<ProductStatistics />} />
                <Route path='incomes' element={<ProductIncomes />} />
                <Route path='top-rating' element={<ProductRatings />} />
              </Route>
              <Route
                element={
                  <RequireChildAuth
                    parentPermission='SETTINGS'
                    permissionCode='SETTINGS_PERMISSIONS'
                  >
                    <ExpenseStatisticsLayout />
                  </RequireChildAuth>
                }
                path='expense'
              >
                <Route index element={<Navigate to='income-outcome' />} />
                <Route
                  path='income-outcome'
                  element={<ExpenseIncomeOutcomeStatistics />}
                />
              </Route>
              <Route path='not-found' element={<NotFoundPage />} />
            </Route>
          </Route>
          <Route path='*' element={<NotFoundPage />} />
        </Route>
      </Route>
    </Route>
  )
);

export default router;
